import * as yup from "yup";

import { VEHICLE_LOCATION_SCHEMA } from "ui/modules/fleet/vehicles/pages/components/VehicleLocationFields/validation";

/**
 * Shema premještaja: pravila lokacije + obavezan naziv i vozač. Naziv i vozač se traže
 * samo ovdje — kod unosa vozila i promjene statusa lokacija nastaje bez da je itko vozio
 * i bez da je premještaj imenovan, pa tamo vrijedi gola `VEHICLE_LOCATION_SCHEMA`.
 */
export const VEHICLE_TRANSFER_SCHEMA = VEHICLE_LOCATION_SCHEMA.shape({
  name: yup
    .string()
    .nullable()
    .trim()
    .required("Naziv premještaja je obavezan podatak"),

  // Datum se predlaže kao današnji, ali se smije obrisati — bez njega se ne zna
  // od kada nova lokacija vrijedi.
  validFrom: yup
    .date()
    .nullable()
    .required("Datum premještaja je obavezan podatak"),

  driverId: yup.string().nullable().required("Odaberite vozača"),
});
